module.exports = __webpack_public_path__ + "static/media/ios-american-football.f5ad3ee8.svg";